import { useState, useEffect } from "react";
import { CircularProgress, Box, Fade } from "@mui/material";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

const LoadingIndicator = ({ isLoading }) => {
    const [showCheck, setShowCheck] = useState(false);
    const [wasLoading, setWasLoading] = useState(false);

    useEffect(() => {
        if (isLoading) {
            setWasLoading(true);
        } else if (wasLoading) {
            setShowCheck(true);
            const timer = setTimeout(() => setShowCheck(false), 2000);
            return () => clearTimeout(timer);
        }
    }, [isLoading, wasLoading]);

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100%"
            sx={{ mt: 1.5 }}
        >
            {isLoading ? (
                <CircularProgress size={24} thickness={4} />
            ) : (
                <Fade in={showCheck}>
                    <TaskAltIcon sx={{ color: "success.main", fontSize: 40 }} />
                </Fade>
            )}
        </Box>
    );
};

export default LoadingIndicator;
